import React from "react";
import {FormattedMessage} from 'react-intl';

function AllProductsActionsBar(props) {
    return (
      <div data-qa="actionsbar-all-products" className={props.isVisible ? "actionsbar show" : "actionsbar"}>
          <div className="row buttons-row">
              <button data-qa="actionsbar-all-products-submit-btn" className={props.btnClassName} onClick={props.buttonAction}>
                  {props.buttonName}
              </button>
          </div>

          <div className="row text-row">
              <p className="total-products">{props.totalProducts}  {props.totalProducts !==1 ?  <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>   }  </p>
              <p className="total-price">{props.totalPrice}</p>
          </div>

      </div>
    );
}

export default AllProductsActionsBar;
